module.exports = __webpack_public_path__ + "img/yachthouse_infraestrutura.6e641b99.jpg";